"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _identity = _interopRequireDefault(require("./identity"));

var _reduce = _interopRequireDefault(require("./reduce"));

var _default = (0, _unmutable.default)({
  name: "toObject",
  immutable: "toObject",
  object: function object() {
    return (0, _identity.default)();
  },
  array: function array() {
    return (0, _reduce.default)(function (obj, value, index) {
      return (0, _objectSpread3.default)({}, obj, (0, _defineProperty2.default)({}, index, value));
    }, {});
  }
});

exports.default = _default;